import useSWR, { SWRResponse } from "swr";
// @ts-ignore
import useHttpClient from "../useHttpClient";
import { AxiosInstance } from "axios";

export interface RelatedChannel {
  id: number;
  title: string;
  url: string;
  state: string;
  relationTitle: string;
}

interface RelatedChannelsResponse {
  data: RelatedChannel[];
}

const useRelatedChannels = (): SWRResponse<RelatedChannelsResponse, Error> => {
  const httpClient: AxiosInstance = useHttpClient();

  return useSWR(
    "related-channels",
    async (): Promise<RelatedChannelsResponse> => {
      const response = await httpClient.get("/channels/related");
      return { data: response.data.data ?? [] };
    },
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
    }
  );
};

export default useRelatedChannels;
